//* 오늘 위치는 여기 없다 — 응답의 todayDayIndex가 SSOT다. 서버는 스키마 enum에 TODAY가
//* 있는데도 실제로는 보내지 않아(체크인 전 UPCOMING·후 ATTENDED) 이 자리에 두면 죽는다.
export type CloverStatus = 'earned' | 'skipped' | 'upcoming';

export interface CloverDay {
  /** 사이클 내 일차 (1~7) */
  day: number;
  /** 해당 일차 출석 시 지급되는 행운권 수 (1·3·7일차에 보너스) */
  reward: number;
  status: CloverStatus;
}

export const CLOVER_CYCLE_LENGTH = 7;

//* 지급 규칙은 flow-map.html(SSOT): 1일=1장, 3일 연속=2장, 7일 연속=3장, 그 외 1장.
const CLOVER_REWARD_BY_DAY: Record<number, number> = {
  1: 1,
  2: 1,
  3: 2,
  4: 1,
  5: 1,
  6: 1,
  7: 3,
};

/** 해당 일차 출석 시 지급되는 행운권 수. */
export const getCloverReward = (day: number): number =>
  CLOVER_REWARD_BY_DAY[day] ?? 1;

//* TODAY는 폴백(upcoming)으로 흡수한다 — 아이콘이 어차피 같은 실버라 화면은 동일하다.
const CLOVER_STATUS_BY_SERVER_STATUS: Record<string, CloverStatus> = {
  ATTENDED: 'earned',
  SKIPPED: 'skipped',
  UPCOMING: 'upcoming',
};

interface AttendanceDayInput {
  dayIndex?: number;
  status?: string;
  rewardCount?: number;
}

const hasDayIndex = (
  attendanceDay: AttendanceDayInput,
): attendanceDay is AttendanceDayInput & { dayIndex: number } =>
  attendanceDay.dayIndex !== undefined;

/** 서버 출석 캘린더(days)를 클로버 스트립 표시 모델로 변환한다. */
export const mapAttendanceDaysToClover = (
  days: AttendanceDayInput[],
): CloverDay[] =>
  [...days]
    .filter(hasDayIndex)
    .sort((first, second) => first.dayIndex - second.dayIndex)
    .map((attendanceDay) => ({
      day: attendanceDay.dayIndex,
      reward:
        attendanceDay.rewardCount ?? getCloverReward(attendanceDay.dayIndex),
      status:
        CLOVER_STATUS_BY_SERVER_STATUS[attendanceDay.status ?? ''] ??
        'upcoming',
    }));
